import { FC } from 'react';
import { Spin } from 'antd';

interface IProps {
  text: string;
  size?: 'large' | 'small' | 'default';
  style?: Record<string, string>;
}

const Spinner: FC<IProps> = (props) => {
  const { text, size = 'large', style = {} } = props;
  return (
    <div className={"center"} style={style}>
      <Spin tip={text} size={size}/>
    </div>
  );
}

export default Spinner;